<div class="d-flex flex-column h-100">
    <div class="overflow-hidden d-flex flex-column gap-4">
        <div class="notifications-header d-flex flex-column gap-4">
            <button type="button" class="btn-close ms-auto" aria-label="Close" 
                (click)="closeNotificationsPopOverEvt($event)"
            >
            </button>

            <div class="d-flex align-items-center gap-2">
                <div class="flex-grow-1 d-flex flex-column">
                    <div class="title-box fw-bold">
                        {{'notification.title' | translate}}
                    </div>

                    <div class="subtitle-box">
                        <span class="text-primary fw-bold">
                            {{unreadCount}}
                        </span>

                        {{'notification.subtitle' | translate}}
                    </div>
                </div>
            </div>
        </div>

        <div class="notifications-body flex-grow-1 overflow-y-auto pe-2">
            <div class="filter-box d-flex align-items-center">
                <button class="filter-btn" [ngClass]="{'filter-btn-active': filter === 0}"
                    (click)="filterHandler('All')" [disabled]="filter === 0">
                    {{'notification.filter.all' | translate}}
                </button>

                <button class="filter-btn" [ngClass]="{'filter-btn-active': filter === 1}"
                    (click)="filterHandler('TAP_ContractExpiry')" [disabled]="filter === 1">
                    {{'notification.filter.contract' | translate}}
                </button>

                <button class="filter-btn" [ngClass]="{'filter-btn-active': filter === 2}"
                    (click)="filterHandler('Asset')" [disabled]="filter === 2">
                    {{'notification.filter.asset' | translate}}
                </button>

                <button class="filter-btn" [ngClass]="{'filter-btn-active': filter === 3}"
                    (click)="filterHandler('System')" [disabled]="filter === 3">
                    {{'notification.filter.system' | translate}}
                </button>
            </div>

            <div *ngFor="let notification of filteredNotifications; let indexNotification = index" class="d-flex flex-column mt-4" 
                [ngClass]="{ 
                    'cursor-pointer' : notification.isLink || !notification.isRead,
                    'fw-bold': !notification.isRead
                }" 
                (click)="notificationClickHandler(notification)">
                <span class="read-bubble rounded-circle" *ngIf="!notification.isRead"></span>
                <div class="d-flex">
                    <div class="notification-icon-container flex-shrink-0 d-flex align-items-center justify-content-center rounded-circle">
                        <i class="notification-icon app-icon icon icon-{{notification.iconName}} icon-xl2"></i>
                    </div>
                    <div class="notification-txt"
                        [innerHtml]="notification.notificationBody">
                    </div>
                </div>

                <span HJSuppress class="notification-received-timestamp">
                    {{displayReceivedDate(notification.createdOn)}}
                </span>
                <div *ngIf="indexNotification < filteredNotifications?.length - 1" class="notification-separator"></div>
            </div>
        </div>
    </div>
</div>
